import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsPageComponent } from './pages/bookings-page/bookings-page.component';
import { BookingsImportPageComponent } from './pages/bookings-import-page/bookings-import-page.component';
import { BookingImportDetailPageComponent } from './pages/booking-import-detail-page/booking-import-detail-page.component';
import { SharedModule } from '../shared/shared.module';
import { PrivateBookingMainFormComponent } from './components/private-booking-main-form/private-booking-main-form.component';
import { PrivateBookingDateSubformComponent } from './components/private-booking-date-subform/private-booking-date-subform.component';
import { BookingsListComponent } from './components/bookings-list/bookings-list.component';
import { BookingsCalendarViewComponent } from './components/bookings-calendar-view/bookings-calendar-view.component';
import { RoomDetailsModalComponent } from './components/room-details-modal/room-details-modal.component';
import { BookingDetailsModalComponent } from './components/booking-details-modal/booking-details-modal.component';
import { PendingBookingsComponent } from './components/pending-bookings/pending-bookings.component';
import { PublicBookingEditModalComponent } from './components/public-booking-edit-modal/public-booking-edit-modal.component';
import { InvoiceModalComponent } from './components/invoice-modal/invoice-modal.component';
import { BookingsListViewComponent } from './components/bookings-list-view/bookings-list-view.component';
import { PersonalBookingsModalComponent } from './components/personal-bookings-modal/personal-bookings-modal.component';
import { SharedManagerModule } from '../shared-manager/shared-manager.module';
import { BookingCalendarBlockComponent } from './components/booking-calendar-block/booking-calendar-block.component';
import { BookingCalendarRoomComponent } from './components/booking-calendar-room/booking-calendar-room.component';
import { BookingCharacteristicIconsComponent } from './components/booking-characteristic-icons/booking-characteristic-icons.component';
import { CalendarRoomMenuComponent } from './components/calendar-room-menu/calendar-room-menu.component';
import { BookingsMonthViewComponent } from './components/bookings-month-view/bookings-month-view.component';
import { BookingsRoomsSidebarComponent } from './components/bookings-rooms-sidebar/bookings-rooms-sidebar.component';
import { TooltipDirective } from '../shared/directives/tooltip.directive';

@NgModule({
  declarations: [
    BookingsPageComponent,
    BookingsImportPageComponent,
    BookingImportDetailPageComponent,
    PrivateBookingMainFormComponent,
    PrivateBookingDateSubformComponent,
    BookingsListComponent,
    BookingsCalendarViewComponent,
    RoomDetailsModalComponent,
    BookingDetailsModalComponent,
    PendingBookingsComponent,
    BookingsListViewComponent,
    PublicBookingEditModalComponent,
    InvoiceModalComponent,
    PersonalBookingsModalComponent,
    BookingCalendarBlockComponent,
    BookingCalendarRoomComponent,
    BookingsMonthViewComponent,
    BookingCharacteristicIconsComponent,
    CalendarRoomMenuComponent,
    BookingsRoomsSidebarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedManagerModule,
    BookingsRoutingModule,
    TooltipDirective,
  ],
  exports: [PublicBookingEditModalComponent, RoomDetailsModalComponent],
})
export class BookingsModule {}
